import type { ProcedureType } from '@/types/cgt'

/**
 * One fixed colour per procedure type: the procedure volume report's chart
 * series and the Overall Status board's card headers.
 *
 * Never assigned by rank and never cycled: a reader must find Transplant the
 * same blue everywhere. Adding a type means taking the next validated slot, not
 * generating one.
 *
 * Validated as a six-slot categorical set against a light surface (slot 6,
 * green, added for Equipment). Three slots
 * sit under 3:1 contrast, so a type is never carried by colour alone: every use
 * pairs it with the type's label.
 */
export const PROCEDURE_TYPE_COLOR: Record<ProcedureType, string> = {
  Transplant: '#2a78d6',
  MES: '#eb6834',
  KitCreation: '#1baf7a',
  Cleaning: '#eda100',
  Inventory: '#e87ba4',
  Equipment: '#008300',
}
